import { render, staticRenderFns } from "./developer-edit-app.vue?vue&type=template&id=88cd91a4&scoped=true&"
import script from "./developer-edit-app.vue?vue&type=script&lang=js&"
export * from "./developer-edit-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cd91a4",
  null
  
)

export default component.exports